import React, { Component } from "react"
import { BrowserRouter as Router, Route } from "react-router-dom"
import { Security, SecureRoute, ImplicitCallback } from "@okta/okta-react"

import Home from "./components/pages/Home"
import Secure from "./components/pages/Secure"
import Login from "./components/auth/Login"

import "./App.css"

function onAuthRequired({ history }) {
  history.push("/login")
}

class App extends Component {
  render() {
    return (
      <Router>
        <Security
          issuer="https://nesterra.okta.com/oauth2/default"
          client_id="0oaf2bdrxmiPwI1If356"
          redirect_uri={window.location.origin + "/implicit/callback"}
          onAuthRequired={onAuthRequired}
        >
          <div className="App">
            <div className="container-fluid">
              <Route path="/" exact={true} component={Home} />
              <Route path="/index.html" exact={true} component={Home} />
              <SecureRoute path="/secure" exact={true} component={Secure} />
              <Route
                path="/login"
                render={() => <Login baseUrl="https://nesterra.okta.com" />}
              />
              <Route path="/implicit/callback" component={ImplicitCallback} />
            </div>
          </div>
        </Security>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js